module.exports = __webpack_public_path__ + "static/media/fiori.8d791cf0.gif";